import React from 'react';

import {observer} from 'mobx-react';
import {BaseProps} from "../../../../infrastructure/models/props/base-props";
import {SeeAllFooterWidget} from "../../../../core/components/see-all-footer/see-all-footer";

export class EntityScoresWidgetSectionFooterProps extends BaseProps {}

export const EntityScoresWidgetSectionFooter = observer(({
                                                           controller,
                                                           section,
                                                           onSeeAllClick
                                                         }: EntityScoresWidgetSectionFooterProps) => {
    const {sortIndex, footerLabel, linkModel} = section;
    const {device} = controller;
    const {isRtl} = device;

    const onClick = () => {
      onSeeAllClick && onSeeAllClick(sortIndex, true);

      return true;
    }

    const seeAllFooterProps = {
      controller,
      onClick: () => onClick(),
      buttonLabel: footerLabel,
      linkModel: !onSeeAllClick ? linkModel : null,
      isRtl,
    };

    return <SeeAllFooterWidget {...seeAllFooterProps} />
  }
);
